import type { QualityTrendApiResponse } from '@/entities/quality/api/getQualityTrend';

/**
 * 같은 날짜의 dataZone별 데이터를 합산
 * @param data QualityTrendApiResponse[]
 * @returns Record<string, { good: number; poor: number; unknown: number }>
 * @example
 * groupByDateTotals([
 *   { statDate: '2025-01-01', goodRows: 100, poorRows: 20, unknownRows: 10 },
 *   { statDate: '2025-01-01', goodRows: 100, poorRows: 20, unknownRows: 10 },
 *   { statDate: '2025-01-02', goodRows: 100, poorRows: 20, unknownRows: 10 },
 * ])
 * // returns: { '2025-01-01': { good: 200, poor: 40, unknown: 20 }, '2025-01-02': { good: 100, poor: 20, unknown: 10 } }
 */
export const groupByDateTotals = (data: QualityTrendApiResponse[]) => {
  return data.reduce(
    (acc, item) => {
      const date = item.statDate;
      if (!acc[date]) {
        acc[date] = { good: 0, poor: 0, unknown: 0 };
      }

      acc[date].good += item.goodRows;
      acc[date].poor += item.poorRows;
      acc[date].unknown += item.unknownRows;

      return acc;
    },
    {} as Record<string, { good: number; poor: number; unknown: number }>
  );
};
